import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, Shield, Award, CalendarDays, KeyRound, Newspaper } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <div className="min-h-screen text-[#FAFAFA]" data-testid="app-layout">
      <header className="sticky top-0 z-30 bg-[#050505]/85 backdrop-blur-xl border-b border-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between gap-3">
          <Link to="/dashboard" className="crest text-[10px] md:text-xs" data-testid="brand-link">
            <span className="text-[#D4AF37] text-lg md:text-xl leading-none">◇</span>
            <span className="hidden sm:inline">The Boardroom</span>
            <span className="sm:hidden">Boardroom</span>
          </Link>
          <nav className="flex items-center gap-3 md:gap-5 text-[10px] md:text-xs tracking-widest uppercase text-neutral-400">
            <Link to="/dashboard" data-testid="nav-dashboard"
              className={`hover:text-[#D4AF37] transition flex items-center gap-2 ${loc.pathname === "/dashboard" ? "text-[#D4AF37]" : ""}`}>
              <LayoutDashboard size={14} /> <span className="hidden sm:inline">Curriculum</span>
            </Link>
            <Link to="/outlook" data-testid="nav-outlook"
              className={`hover:text-[#D4AF37] transition flex items-center gap-2 ${loc.pathname === "/outlook" ? "text-[#D4AF37]" : ""}`}>
              <CalendarDays size={14} /> <span className="hidden sm:inline">Outlook</span>
            </Link>
            <Link to="/intel" data-testid="nav-intel"
              className={`hover:text-[#D4AF37] transition flex items-center gap-2 ${loc.pathname === "/intel" ? "text-[#D4AF37]" : ""}`}>
              <Newspaper size={14} /> <span className="hidden sm:inline">Intel</span>
            </Link>
            {user?.role === "admin" && (
              <Link to="/admin" data-testid="nav-admin"
                className={`hover:text-[#D4AF37] transition flex items-center gap-2 ${loc.pathname.startsWith("/admin") ? "text-[#D4AF37]" : ""}`}>
                <Shield size={14} /> <span className="hidden sm:inline">Admin</span>
              </Link>
            )}
            <Link to="/certificate" data-testid="nav-cert"
              className={`hover:text-[#D4AF37] transition flex items-center gap-2 ${loc.pathname === "/certificate" ? "text-[#D4AF37]" : ""}`}>
              <Award size={14} /> <span className="hidden sm:inline">Certificate</span>
            </Link>
            <Link to="/set-password" data-testid="nav-change-pw"
              className={`hover:text-[#D4AF37] transition flex items-center gap-2 ${loc.pathname === "/set-password" ? "text-[#D4AF37]" : ""}`}
              title="Change password">
              <KeyRound size={14} />
            </Link>
            <div className="hidden md:flex flex-col items-end pl-4 border-l border-[#1a1a1a]">
              <span className="text-[10px] text-[#AA8A25]">Signed in</span>
              <span className="text-xs text-neutral-200 normal-case tracking-normal font-body">
                {user?.email}
              </span>
            </div>
            <button data-testid="logout-btn"
              onClick={async () => { await logout(); nav("/login"); }}
              className="text-neutral-400 hover:text-[#D4AF37] flex items-center gap-2">
              <LogOut size={14} /> <span className="hidden sm:inline">Exit</span>
            </button>
          </nav>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-10 animate-fade-up">{children}</main>
      <footer className="py-10 text-center overline">◇ The Boardroom · Private Trading Syndicate ◇</footer>
    </div>
  );
}
